import { useFormik } from 'formik';
import React from 'react';
import { Col, Row } from 'react-bootstrap';
import { appointmentReminderSchema } from '../../../Schema';
import { timeUnits } from '../../../data';
import Button from '../../UI/Button';
import Dropdown from '../../UI/Dropdown';
import { Input } from '../../UI/Input';
import classes from './AppointmentReminder.module.css';
const initialValues = {
  time: 24,
  quantity: { label: 'Hour', value: 'H' }
};
const AppointmentReminder = ({ onSubmit }) => {
  const formik = useFormik({
    initialValues,
    validationSchema: appointmentReminderSchema,
    onSubmit: (values, { resetForm }) => {
      onSubmit(`${values?.time}-${values?.quantity?.value}`, () => {
        resetForm();
      });
    }
  });
  const { touched, errors, values, handleSubmit, setFieldValue, setFieldTouched, resetForm } =
    formik;
  const handleChangeWithTouch = (field, value) => {
    setFieldValue(field, value);
    setFieldTouched(field, true, false); // Mark field as touched manually
  };

  const formSubmit = () => {
    if (Object.keys(errors)?.length === 0) {
      onSubmit(`${values?.time}-${values?.quantity?.value}`, () => {
        resetForm();
      });
    }
  };
  return (
    <form className={classes.wrapper}>
      <h2 className={classes.heading}>Appointment Reminder SMS</h2>
      <p className={classes.note}>Send an SMS before every scheduled appointment</p>
      <Row>
        <Col sm={6}>
          <Input
            placeholder="Enter Duration"
            value={values?.time}
            label={'Duration Per Patient'}
            setter={(value) => {
              handleChangeWithTouch('time', value);
            }}
            errorText={touched?.time && errors?.time} // Show error if touched
          />
        </Col>
        <Col sm={6}>
          <Dropdown
            value={values?.quantity}
            options={timeUnits?.filter((ele) => ele?.value !== values?.quantity?.value)}
            label={'Follow Up'}
            setter={(value) => {
              handleChangeWithTouch('quantity', value);
            }}
          />
        </Col>
      </Row>
      <div className={classes.ctaWrapper}>
        <Button variants="secondary" label={'Cancel'} />
        <Button onClick={formSubmit} variants="primary" label={'Confirm'} />
      </div>
    </form>
  );
};

export default AppointmentReminder;
